import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row, Button } from 'react-bootstrap';
import logo2 from '../../assets/img/logo_macizo1.png';
import TextFieldGroup from '../TextFieldGroup/TextFieldGroup';
import { rutas } from '../../routes_backend/routes';
class EmailForgotPassword extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: '',
			success: false,
			emailUser: '',
			message: ''
		};
		this.onChange = this.onChange.bind(this);
	}
	onChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}
	handlerBackLogin = () => this.props.history.push('/');
	onSubmit = (email) => {
		if (email === '') {
			return this.setState({
				message: 'Ingrese E-mail'
			});
		}
		let url = `${rutas.send_token}?email=${email}`;
		fetch(url)
			.then(async (res) => {
				let data = await res.json();
				if (data === 'Exito') {
					this.props.history.push('/resetPassword');
				}
				this.setState({
					message: data
				});
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					message: 'error in the server'
				});
			});
	};
	render() {
		const { error, emailUser, message } = this.state;

		return (
			<div className="content">
				{' '}
				<div className="col-md-4 col-md-offset-4">
					<div className="content">
						<Grid>
							<Row>
								<div className="col-md-6">
									<div className="jumbotron jumbotron-fluid">
										<div className="content">
											<div className="logo-img">
												<img style={styles.logo} src={logo2} alt="Logo SFSUPD" />
											</div>
											<h3 align="center" className="display-4">
												Olvidaste tu contraseña?
											</h3>
											<br />
											<p style={styles.token}>
												Se enviara un "Token" al E-mail ingresado que servira para restablecer
												tu contraseña
											</p>
											<br />
											<br />
											<div style={styles.animation}>
												{error ? (
													<div className="alert alert-danger" role="alert">
														{error}
													</div>
												) : null}
											</div>
											<Col style={styles.animation}>
												<TextFieldGroup
													field="emailUser"
													label="E-mail Macizo: "
													type="emailUser"
													name="emailUser"
													value={emailUser ? emailUser : ''}
													onChange={this.onChange}
													error={error}
												/>
											</Col>
											<div style={{ display: 'flex', justifyContent: 'center' }}>
												<Button
													bsStyle="primary"
													bsSize="large"
													active
													onClick={() => this.onSubmit(emailUser)}
												>
													Enviar E-mail
												</Button>
												<br />
											</div>
											<p style={styles.errorMessage}>{message}</p>
											<div style={styles.backBotton}>
												<p onClick={this.handlerBackLogin}>Back</p>
											</div>
										</div>
									</div>
								</div>
							</Row>
						</Grid>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(EmailForgotPassword);
const styles = {
	wrapperContainer: {
		display: 'flex',
		flexWrap: 'flexWrap',
		alignItems: 'flex-end'
	},
	animation: {
		transition: 'all 1s ease'
	},
	WrapperContent: {
		margin: 'auto',
		width: '100%',
		padding: '1em 12em'
	},
	styleHeaderForgotPassword: {
		display: 'flex',
		flexWrap: 'flexWrap',
		alignItems: 'center'
	},
	textHeaderForgot: {
		display: 'flex'
	},
	wrapperLogo: {
		display: 'flex',
		flexWrap: 'flexWrap',
		width: '56%',
		justifyContent: 'flex-end',
		alignContent: 'center',
		padding: '1em auto'
	},
	logo: {
		width: '50%',
		marginLeft: '25%'
	},
	logoToken: {
		height: '2.5em',
		width: 'auto'
	},
	styleForgotMessage: {
		fontSize: '1.5rem',
		cursor: 'pointer',
		color: '#g5g5g5',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	backBotton: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignContent: 'base-line',
		cursor: 'pointer'
	},
	errorMessage: {
		fontWeight: 'bold',
		fontSize: '12px',
		height: '10px',
		color: 'red',
		textAlign: 'center',
		alignItems: 'center'
	},
	token: {
		fontWeight: 'bold',
		fontSize: '14px',
		height: '10px'
	}
};
